import { JDN_ENUMS, STATE_ENUMS } from "./jurisdictionEnums";

export const flAllowRcv = {
  url: "fl-ranked-choice-voting",
  fireDbPath: "flAllowRcv",
  uiTitle: "Ranked Choice Voting",
  tileDescription:
    "Allow local governments to implement ranked choice voting for their elections.",
  jurisdiction: {
    jdn: JDN_ENUMS.STATE,
    state: STATE_ENUMS.fl,
  },
  fullText: (
    <>
      Here we call for the state of Florida to allow any city, county, or
      municipality to implement ranked choice voting for their local elections.
      <br />
      <br />
      In 2022, the Florida Legislature banned ranked choice voting statewide,
      overriding the democratic will of communities like Sarasota, where voters
      had chosen to adopt ranked choice voting. We call for the repeal of this
      ban and the restoration of every Florida {"community's"} freedom to adopt
      ranked choice voting for their local elections.
    </>
  ),
};
